export default "__VITE_ASSET__Wb0XK1V0__"